module.exports = __webpack_public_path__ + "static/media/features-split-image-01.ed6bf5b8.png";